import { tryParseAsNumber } from '@leid/helpers'
import { SelectOption } from 'components/form/Select/useSelect'
import { CoordinatesCookieData } from 'utils/cookies/models'
import { SortingInfo } from 'appTypes/mapper'

// Types
export type LocationInfo = {
  error: boolean
  lat: number | undefined
  long: number | undefined
}

// Constants
export const COOKIE_CHECK_INTERVAL = 200
export const GEOLOCATION_TIMEOUT = 10000
export const GEOLOCATION_MAX_AGE = 60000
export const PULSE_ANIMATION_DURATION = '3s'

// Utility functions
export const coordinatesToString = (lat: number | undefined, long: number | undefined): string => {
  return `${lat ?? ''}:${long ?? ''}`
}

export const stringToCoordinates = (value: string): { lat: number | undefined; long: number | undefined } => {
  const parts = value.split(':')
  if (parts.length !== 2) {
    return { lat: undefined, long: undefined }
  }

  const lat = tryParseAsNumber(parts[0])
  const long = tryParseAsNumber(parts[1])
  return { lat, long }
}

export const createCoordinatesData = (
  currentLocation: LocationInfo | undefined,
  selectedOption: SelectOption | undefined,
): CoordinatesCookieData | undefined => {
  if (currentLocation && !currentLocation.error && currentLocation.lat && currentLocation.long) {
    return {
      lat: currentLocation.lat,
      long: currentLocation.long,
      label: undefined,
    }
  }

  if (selectedOption?.value) {
    const { lat, long } = stringToCoordinates(selectedOption.value.toString())
    return {
      lat,
      long,
      label: selectedOption.label,
    }
  }

  return undefined
}

export const createSortingInfo = (coordinatesData: CoordinatesCookieData): SortingInfo | undefined => {
  if (coordinatesData?.lat !== undefined && coordinatesData?.long !== undefined) {
    return {
      lat: coordinatesData.lat,
      long: coordinatesData.long,
      text: coordinatesData.label || 'currentPosition',
      multilang: true,
    }
  }
  return undefined
}

export const getBannerCookie = (): string | undefined => {
  if (typeof document === 'undefined') return undefined

  const match = document.cookie.match(new RegExp(`(^| )CookieInformationConsent=([^;]+)`))
  return match ? match[2] : undefined
}

export const shouldOpenOnStartup = (
  showOnStartup: boolean,
  isProd: boolean,
  bannerCookie: string | undefined,
  isLoggedIn: boolean,
  sortingInfo: SortingInfo | undefined,
): boolean => {
  if (!showOnStartup) return false
  if (isProd && !bannerCookie) return false
  return !isLoggedIn && sortingInfo === undefined
}
